import React from 'react'
import './contentFilter.css'

class ContentFilter extends React.PureComponent {

  render() {
    const {FILTERS, applyFilter, className, filtersStatuses} = this.props
    const classNames = ['content-filter', className]
    return (
      <label
        className={classNames.join(' ')}
      >
        <select
          onChange={(e) => applyFilter(e.target.value)}
          className='content-filter__select'>
          {Object.keys(FILTERS).map(filter => (
            <option
              disabled={!filtersStatuses[FILTERS[filter]]}
              value={filter}
              key={filter}
            >
              {filter}
            </option>
          ))}
        </select>
      </label>
    )
  }
}

export default ContentFilter



// WEBPACK FOOTER //
// ./src/core/components/content-filter/ContentFilter.js